<template lang="pug">
 .site-view
    el-breadcrumb.mt-3.last-breadcrumb-bold(style="font-size: 22px;" separator="/")
      el-breadcrumb-item {{ 'Management' }}
      el-breadcrumb-item {{ 'Transmitters' }}
    br
    .filters
      FilterSiteDropdown(v-model="selectedSiteId")
      FilterFirmwareVersion(v-model="firmwareVersion")
      FilterFirmwareStatus(v-model="firmwareStatus")
    .site-wrapper
      .actions
        SearchWithButtons(
          v-model="search"
          :showSearch="true"
        )
      el-row
        el-col(:span='24')
          TransmittersViewTable(
            v-loading="loading"
            :transmitters="transmitters"
          )
    Pagination(
      :view="'transmitters'"
      :search="search"
      :siteId="selectedSiteId"
      :firmwareVersion="firmwareVersion"
      :firmwareStatus="firmwareStatus"
      @viewData="handleGetTransmitters"
      @handleTableLoading="handleLoading"
    )

</template>

<script>
import Pagination from "@components/_shared/Pagination";
import SearchWithButtons from "@components/_shared/SearchWithButtons";
import TransmittersViewTable from "@components/transmitters/TransmittersViewTable";
import FilterSiteDropdown from "@components/_shared/FilterSiteDropdown";
import FilterFirmwareVersion from "@components/_shared/FilterFirmwareVersion";
import FilterFirmwareStatus from "@components/_shared/FilterFirmwareStatus";
import { mapMutations, mapState } from "vuex";

export default {
  name: 'TransmittersView',
  components: { Pagination, SearchWithButtons, TransmittersViewTable,
    FilterSiteDropdown, FilterFirmwareVersion, FilterFirmwareStatus
   },

  data() {
    return {
      selectedSiteId: "",
      search: "",
      firmwareVersion: "",
      firmwareStatus: "",
      transmitters: [],
      loading: false,
    };
  },

  computed: {
    ...mapState("auth", ["user"]),
  },

  methods: {
    ...mapMutations("dialog", ["showAddSiteDialog"]),

    handleGetTransmitters(data) {
      this.transmitters = data;
    },

    handleLoading(loading) {
      this.loading = loading;
    },

    handleOpenAddSiteDialog() {
      this.showAddSiteDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.filters {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;

  :deep(.sites-filter),
  :deep(.firmware-version-filter),
  :deep(.firmware-status-filter) {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 180px;

    .filter-title {
      font-size: 12px;
      font-weight: 600;
      color: #606266;
    }

    .el-select {
      width: 100%;
    }
  }
}
</style>
